import { OrganisationPutSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import ASRSelect from "Components/Shared/ASRSelect";
import FormSubmit from "Components/Shared/FormSubmit";
import ProductTableSelect from "Components/Shared/ProductTableSelect";
import RatingTableSelect from "Components/Shared/RatingTableSelect";
import TimezoneSelect from "Components/Shared/TimezoneSelect";
import TTSSelect from "Components/Shared/TTSSelect";
import { FastField, Field, Formik } from "formik";
import { useOrganisation } from "Hooks/Endpoints";
import React from "react";
import { Form, Segment } from "semantic-ui-react";

function OrganisationGeneralForm() {
  const { organisation, update, validateName, ratingTables, productTables } =
    useOrganisation();
  return (
    <Segment>
      <Formik
        validateOnChange={false}
        initialValues={organisation}
        validationSchema={OrganisationPutSchema}
        onSubmit={(values, actions) => {
          update(values);
        }}
      >
        {({ handleSubmit, errors }) => (
          <Form onSubmit={handleSubmit}>
            <Field
              name='id'
              label='ID'
              disabled={true}
              component={CallableInput}
            />

            <FastField
              name='name'
              label='Name'
              validate={validateName}
              component={CallableInput}
            />

            <RatingTableSelect
              name='terminationRates'
              label='Termination Rates'
              appliedAt='termination'
              ratingTables={ratingTables}
            />

            <RatingTableSelect
              name='originationRates'
              label='Origination Rates'
              appliedAt='origination'
              ratingTables={ratingTables}
            />

            <ProductTableSelect
              name='productTable'
              label='Product Table'
              productTables={productTables}
            />

            <TimezoneSelect name='timeZone' label='Time Zone' />

            <TTSSelect name='ttsLanguage' label='TTS Language' />

            <ASRSelect name='asrLanguage' label='ASR Language' />

            <h2>Direct Billing</h2>

            <RatingTableSelect
              name='terminationRatesRRP'
              label='Termination Rates RRP'
              appliedAt='termination'
              ratingTables={ratingTables}
            />

            <RatingTableSelect
              name='originationRatesRRP'
              label='Origination Rates RRP'
              appliedAt='origination'
              ratingTables={ratingTables}
            />

            <ProductTableSelect
              name='productTableRRP'
              label='Product Table RRP'
              productTables={productTables}
            />

            <FastField
              name='cdrSettings.type'
              label='Type'
              placeholder='xero'
              component={CallableInput}
            />

            <FastField
              name='cdrSettings.username'
              label='Secret Key'
              component={CallableInput}
            />

            <FastField
              name='cdrSettings.password'
              label='Secret Value'
              component={CallableInput}
            />

            <FormSubmit name='Update' errors={errors} />
          </Form>
        )}
      </Formik>
    </Segment>
  );
}

export default OrganisationGeneralForm;
